interface WordmarkProps {
  className?: string;
}

export function Wordmark({ className = '' }: WordmarkProps) {
  return (
    <span className={`font-display font-bold tracking-tight text-ink ${className}`}>
      PDPO <span className="text-gold">Go</span>
    </span>
  );
}
